import PropTypes from 'prop-types'

import { CouponLoading } from 'lmcv/components/Coupon'

import * as S from './styled'

function VouchersSkeleton ({ size }) {
  return (
    <S.Carousel>
      {Array(size)
        .fill()
        .map((item, index) => (
          <S.CarouseItem key={`${item}-${index}`}>
            <CouponLoading />
          </S.CarouseItem>
        ))}
    </S.Carousel>
  )
}

VouchersSkeleton.propTypes = {
  size: PropTypes.number
}

VouchersSkeleton.defaultProps = {
  size: 3
}

export default VouchersSkeleton
